import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import client, { getErrorMessage } from "@/api/client";
import { toast } from "sonner";
import { BalanceLabel } from "./imprestShared";

export default function ImprestSettleDialog({ employeeId, employeeName, balance, onClose, onSettled }) {
  const [note, setNote] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (text !== "CONFIRM" || !note.trim()) return;
    setBusy(true);
    try {
      await client.post(`/payment-desk/imprest/employees/${employeeId}/settle`, { confirm: text, note: note.trim() });
      toast.success("Marked settled");
      onSettled();
    } catch (err) {
      toast.error(getErrorMessage(err));
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(open) => !open && !busy && onClose()}>
      <DialogContent className="max-w-md" data-testid="imprest-settle-dialog">
        <DialogHeader>
          <DialogTitle>Mark Settled — {employeeName}</DialogTitle>
          <DialogDescription>Closes the current period. History stays on record and the next entry starts a fresh balance.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2"><BalanceLabel balance={balance} testId="imprest-settle-balance" /></div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Note * (what happened to the balance)</label>
            <Textarea data-testid="imprest-settle-note-input" autoFocus value={note} onChange={(e) => setNote(e.target.value)} />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Type CONFIRM to settle</label>
            <Input data-testid="imprest-settle-confirm-input" value={text} onChange={(e) => setText(e.target.value)} autoComplete="off" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={busy} data-testid="imprest-settle-cancel-button">Cancel</Button>
            <Button type="submit" disabled={busy || text !== "CONFIRM" || !note.trim()} className="bg-emerald-600 hover:bg-emerald-700" data-testid="imprest-settle-submit-button">
              {busy ? "Saving..." : "Mark Settled"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
